import { useCallback } from 'react';

import type { HandlePick, UseMapClickArgs, UseMapClickReturn } from './types';

const useMapClick = ({ onPoint }: UseMapClickArgs): UseMapClickReturn => {
    const handlePick: HandlePick = useCallback(
        ({ lat, lon }) => {
            onPoint({ lat, lng: lon });
        },
        [onPoint]
    );

    return { handlePick };
};

export default useMapClick;
